export const GRID_NB_COLS = 10;
export const ROW_HEIGHT = 40; // pixels
/*
    Row height is now depending on the fixed or full width of the RGLLayoutEngine.
    This fixed and full width modes have been added to help design the pdfs with the fixed width mode
*/
export const ROW_HEIGHT_FULL_WIDTH = 40; // pixels
export const ROW_HEIGHT_FIXED_WIDTH = 50; // pixels
export const VERTICAL_MARGIN = 10; // pixels

/*
Those have been measured empirically.
There is less space in the first page because there are more things in the header.
We had the values:
- Zoom 0.5 -> 38 and 40
- Zoom 0.6 -> 30 and 32
*/
export const NB_RGL_UNIT_ALLOWED_FIRST_PAGE = 30;
export const NB_RGL_UNIT_PER_PRINT_PAGE = 32;
